import React from 'react';
import PropTypes from 'prop-types';
import MultilineTextField from './MultilineTextField';

const FormMultilineTextField = ({
  className,
  input = {},
  meta: { submitFailed, invalid },
  ...props
}) => {
  const isError = submitFailed && invalid;

  return (
    <MultilineTextField
      className={className}
      {...input}
      {...props}
      isError={isError}
    />
  );
};

FormMultilineTextField.propTypes = {
  className: PropTypes.string,
  input: PropTypes.object,
  tip: PropTypes.string,
  meta: PropTypes.shape({
    error: PropTypes.string,
    submitFailed: PropTypes.bool,
    invalid: PropTypes.bool,
  }),
};

export default FormMultilineTextField;
